module.exports = __webpack_public_path__ + "static/media/pink-slider1.9944308d.jpg";